<!-- <div class="calendar-body" [scaleVertically]="0">
<div class="row no-gutters h-100">
  <div class="col h-100 text-center bay-club-blue" *ngFor="let day of calendarData.days">
    <div class="calendar-day calendar-day-border">
      {{day.date | bcDate}}
    </div>
  </div>
</div>
</div> -->

<div class="calendar-body" [scaleVertically]="0">
    <div class="row no-gutters h-100">
        @for (day of calendarData.days; track day) {
            <div class="col h-100">
                <div class="calendar-day calendar-day-border">
                    <div
                        class="calendar-day-header text-center bay-club-blue height-40 line-height-40"
                    >
                        {{ day.date | bcDate }}
                    </div>
                    <div class="padding-side-10">
                        @for (
                            booking of day.bookings
                                | filterby: "isVisible" : true;
                            track booking
                        ) {
                            <div class="card voffset-10">
                                <div class="card-body">
                                    <h5 class="card-title size-16">
                                        {{ booking.child.fullName }}
                                    </h5>
                                    <h6
                                        class="card-subtitle mb-2 text-muted size-14"
                                    >
                                        {{ booking.child.dateOfBirth | bcDate }}
                                    </h6>
                                    <div class="card-text size-12">
                                        <div class="bolded">
                                            Booking details
                                        </div>
                                        <div>
                                            {{
                                                booking.timeFromInMinutes
                                                    | timeDisplay
                                            }}
                                            -
                                            {{
                                                booking.timeToInMinutes
                                                    | timeDisplay
                                            }}
                                        </div>
                                        <div>
                                            {{
                                                day.campCareDay
                                                    .ageRangeFromInMonths | age
                                            }}
                                            -
                                            {{
                                                day.campCareDay
                                                    .ageRangeToInMonths | age
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="card-footer">
                <small class="text-muted">{{booking.createdAt | bcDate: 'MM/dd/yyyy hh:mm:ss'}}</small>
              </div> -->
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
    </div>
</div>
